// Fires event425 and sets vzdl.event.testData to "yes" only when test data is detected.

import { eventDispatcher } from '../components/common/Tagging';

export const TEST_FNAME = 'test';
export const TEST_LNAME = 'test';
export const TEST_SSN = '123456789';

export const isTestData = (firstName = '', lastName = '', ssn = '') =>
  (firstName?.toLowerCase()?.trim().includes(TEST_FNAME) && lastName?.toLowerCase()?.trim().includes(TEST_LNAME)) ||
  ssn?.replace(/\D/g, '') === TEST_SSN;

export const triggerEvent425 = (firstName = '', lastName = '', ssn = '') => {
  if (typeof window === 'undefined') return;

  const testDataFlag = isTestData(firstName, lastName, ssn);

  if (!testDataFlag) return;

  if (window.vzdl) {
    if (!window.vzdl.event) {
      window.vzdl.event = {};
    }
    window.vzdl.event.testData = 'yes';
  }

  eventDispatcher('sendData', {
    name: 'event425',
    events: 'event425',
  });
};

